import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from "@angular/core";
import {
  FileItem,
  FileUploader,
  ParsedResponseHeaders
} from "ng2-file-upload";
import {
  TokenService
} from "../../../services/shared/token.service";
import {
  ToastrService
} from "ngx-toastr";
import {
  Environment
} from "@env/environment.global";

@Component({
  selector: "app-customfileupload",
  templateUrl: "./customfileupload.component.html",
  styleUrls: ["./customfileupload.component.scss"]
})
export class CustomFileUploadComponent implements OnInit {
  @Input()
  public allowAllFiles = false;
  @Input()
  public allowedFile: Array<{ extension: string, count: number }> = new Array<{ extension: string, count: number }>();
  @Input()
  public allowMultiple = true;
  @Input()
  public servicePath = "api/FileUploadService/Upload";
  @Input()
  public maxFileSize = 20 * 1024 * 1024;
  @Input()
  public changeFileName = true;
  @Input()
  public autoUpload = false;
  @Input()
  public hideProgressBar = false;
  @Input()
  public showIndivdualUpload = true;
  @Input()
  public specificationText = "";
  @Input()
  public showWarnings = true;
  @Input()
  public customParams = '';
  @Input()
  public customFileName = '';
  @Input()
  public removeAfterUpload = false;
  @Input()
  public subfolderName = '';

  @Output()
  public uploadedFileChanged = new EventEmitter();
  @Output()
  public onError = new EventEmitter<string>();

  public uploadedFiles = new Array<string>();
  public isProcessEnabled: boolean;
  public uploader: FileUploader;

  public hasBaseDropZoneOver = false;

  private maxFileNameLength = 150;

  constructor(private tokenService: TokenService, private toasterService: ToastrService, private environment: Environment) {

  }

  public onSuccessItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
    if (status === 200) {
      this.uploadedFiles.push(`${response}`);
      this.addNewUploadedFile();
    }
  }

  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  public dropped(e: any) {
    console.log(this.uploader);
  }

  public ngOnInit() {
    this.uploader = this.createUploader(this.servicePath);
    this.uploader.onSuccessItem =
      (item, response, status, headers) => this.onSuccessItem(item, response, status, headers);

    this.uploader.onAfterAddingFile = (fileItem: FileItem) => {
      const fileName = fileItem.file.name;
      if (fileName.length > this.maxFileNameLength) {
        const errorMessage = "File names can be maximum of 150 characters.";
        this.toasterService.warning(errorMessage, "File name is too long");
        this.uploader.removeFromQueue(fileItem);
      }

      if (!this.allowMultiple && this.uploader.queue.length > 1) {
        this.toasterService.warning("Please remove added before adding a new one.", "Only one file can be uploaded");
        this.uploader.removeFromQueue(fileItem);
      }
    };

    this.uploader.onWhenAddingFileFailed =
      (item, filter, options) => {
        const errorMessage = "Please upload files with the correct specifications";
        this.onError.emit(errorMessage);
        if (this.showWarnings) {
          this.toasterService.warning(errorMessage, "File Specs");
        }
      };
  }

  public createUploader(apiURL: string) {
    apiURL = this.environment.getBaseUrl() + apiURL;
    return new FileUploader(
      {
        url: apiURL,
        filters: [
          {
            name: "daExtension",
            fn: (item: any): boolean => {
              const fileExt = item.name.slice(item.name.lastIndexOf(".") + 1).toLowerCase();
              return this.allowAllFiles || (this.allowedFile.map(x => x.extension).includes(fileExt) &&
                this.allowedFile.filter(p => p.extension === fileExt).map(x => x.count)[0] >
                this.uploader.queue.filter(p => p.file.name.includes(`.${fileExt}`)).length);
            }
          }
        ],
        headers: [
          { name: "Authorization", value: `Bearer ${this.tokenService.get('token')}` },
          { name: "changefilename", value: this.changeFileName.toString() },
          { name: "customFileName", value: this.customFileName.toString() },
          { name: "customParams", value: this.customParams.toString() },
          { name: "subfolderName", value: this.subfolderName.toString() }
        ],
        maxFileSize: this.maxFileSize,
        removeAfterUpload: this.removeAfterUpload,
        autoUpload: this.autoUpload
      });
  }

  public addNewUploadedFile() {
    this.uploadedFileChanged.emit(this.uploadedFiles);
  }

  public clearFiles() {
    if (this.uploader) {
      this.uploader.clearQueue();
      this.uploader.cancelAll();
      this.uploader.progress = 0;
    }

    //we need to delete files from server before emptying file list
    this.uploadedFiles = [];
    this.uploadedFileChanged.emit(this.uploadedFiles);
  }
}
